import { render } from "./create-many.vue?vue&type=template&id=49d049b3&ts=true"
import script from "./create-many.vue?vue&type=script&lang=ts"
export * from "./create-many.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__